import styled from '@emotion/styled'

import { spacing } from 'main/ui'

export const DetailContainer = styled.div`
  margin-top: ${spacing.majorScale(1)}px;
  display: flex;
`

export const IconContainer = styled.div`
  width: 20px;
  display: flex;
  align-items: center;
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${spacing.minorScale(3)}px;
`

export const VerificationContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const TagContainer = styled.div`
  margin-bottom: ${spacing.minorScale(3)}px;
`

export const ButtonContainer = styled.div`
  margin-top: ${spacing.minorScale(4)}px;
`
